export const i18n = {
	lastUpdated: {
		id: 'dynamic-cards-search-page.filters.names.lastUpdated',
		defaultMessage: 'Last updated',
		description: 'Label for filtering by last updated time',
	},
};
